var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-forgotten-password"},[_c('div',{staticClass:"page-forgotten-password__content"},[_c('div',{staticClass:"page-forgotten-password__title"},[_vm._v("\n      Forgotten Password\n    ")]),_vm._v(" "),_c('div',{staticClass:"page-forgotten-password__content-wrap"},[_c('account-forgotten')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32690f28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-forgotten-password/page-forgotten-password.vue
// module id = YQaP
// module chunks = 0